import { http } from './config'

export default {
  listarhorario:(ativado) => {
    return http.get('horarios.php?ativado='+ativado)
  },
  horarioAtual:() => {
    return http.get('horario_atual.php?')
  }
}